import TileMini from 'features/cart/components/ProductSummarySegment/ProductThumbnail/TileMini'
import { getCropStyle } from 'features/cart/components/ProductSummarySegment/ProductThumbnail/cropStyle'
import type { CartUpsellThumbnailOfType } from '../../cartUpsells.types'
import * as S from './TileBeforeAfterThumbnail.styles'

export function TileBeforeAfterThumbnail({
  thumbnail,
}: {
  thumbnail: CartUpsellThumbnailOfType<'tile-before-after'>
}) {
  return (
    <S.Row>
      <S.ResultTileBox>
        <TileMini {...thumbnail.resultTile} includeShadow={false} />
      </S.ResultTileBox>
      <S.SourcePhotoClip>
        <S.SourcePhoto
          src={thumbnail.source.imageUrl}
          style={getCropStyle(thumbnail.source.crop)}
          alt=""
        />
      </S.SourcePhotoClip>
      <S.ArrowBox aria-hidden>
        <S.Arrow />
      </S.ArrowBox>
    </S.Row>
  )
}
